import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [productsDropdown, setProductsDropdown] = useState(false);
  const [catalogueDropdown, setCatalogueDropdown] = useState(false);

  // Function to scroll to top when link is clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Handle link click - close mobile menu and scroll to top
  const handleLinkClick = () => {
    setIsOpen(false);
    setProductsDropdown(false);
    setCatalogueDropdown(false);
    scrollToTop();
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={handleLinkClick}>
          <img src="/images/finalLogo.jpg" alt="MasaiLink" className="logo-img" />
          <span className="logo-text">MasaiLink</span>
        </Link>

        <div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
          <i className={isOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
        </div>

        <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={handleLinkClick}>
              Home
            </Link>
          </li>
          
          {/* Products Dropdown */}
          <li className="nav-item dropdown" 
              onMouseEnter={() => setProductsDropdown(true)} 
              onMouseLeave={() => setProductsDropdown(false)}
          >
            <span className="nav-link dropdown-trigger">
              Products <i className="fas fa-chevron-down"></i>
            </span>
            <ul className={`dropdown-menu ${productsDropdown ? 'show' : ''}`}>
              <li>
                <Link to="/products" className="dropdown-item" onClick={handleLinkClick}>
                  <span className="dropdown-icon">⚡</span>
                  <div className="dropdown-content">
                    <strong>Masai Cables</strong>
                    <small>Wires & Cables</small>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/pump-products" className="dropdown-item" onClick={handleLinkClick}>
                  <span className="dropdown-icon">💧</span>
                  <div className="dropdown-content">
                    <strong>Versil Pumps</strong>
                    <small>Submersible & Surface Pumps</small>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/steel-products" className="dropdown-item" onClick={handleLinkClick}>
                  <span className="dropdown-icon">🔩</span>
                  <div className="dropdown-content">
                    <strong>Masai Rolling Mills</strong>
                    <small>TMT Steel & Billets</small>
                  </div>
                </Link>
              </li>
            </ul>
          </li>

          {/* Catalogue Dropdown */}
          <li className="nav-item dropdown" 
              onMouseEnter={() => setCatalogueDropdown(true)} 
              onMouseLeave={() => setCatalogueDropdown(false)}
          >
            <span className="nav-link dropdown-trigger">
              Catalogue <i className="fas fa-chevron-down"></i>
            </span>
            <ul className={`dropdown-menu ${catalogueDropdown ? 'show' : ''}`}>
              <li>
                <Link to="/catalogue" className="dropdown-item" onClick={handleLinkClick}>
                  <span className="dropdown-icon">📋</span>
                  <div className="dropdown-content">
                    <strong>Cable Catalogue</strong>
                    <small>Full cable listings</small>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/pump-catalogue" className="dropdown-item" onClick={handleLinkClick}>
                  <span className="dropdown-icon">📊</span>
                  <div className="dropdown-content">
                    <strong>Pump Catalogue</strong>
                    <small>All Versil pumps</small>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/steel-catalogue" className="dropdown-item" onClick={handleLinkClick}>
                  <span className="dropdown-icon">📏</span>
                  <div className="dropdown-content">
                    <strong>Steel Catalogue</strong>
                    <small>TMT bars & billets</small>
                  </div>
                </Link>
              </li>
            </ul>
          </li>

          <li className="nav-item">
            <Link to="/quote" className="nav-link" onClick={handleLinkClick}>
              Get Quote
            </Link>
          </li>

          <li className="nav-item">
            <Link to="/about" className="nav-link" onClick={handleLinkClick}>
              About
            </Link>
          </li>

          <li className="nav-item">
            <Link to="/contact" className="nav-link" onClick={handleLinkClick}>
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;